import '../lib/intercom';

import type { Customer } from 'api/types/user.types';
import i18n from 'i18n/config';

export default class MessagingService {
  private static instance: MessagingService;

  private constructor() {
    this.initialize();
  }

  public static getInstance(): MessagingService {
    if (!MessagingService.instance) {
      MessagingService.instance = new MessagingService();
    }

    return MessagingService.instance;
  }

  public async initialize() {
    const user = localStorage.getItem('user') as string | null;
    const customer = user ? (JSON.parse(user) as Customer.Customer) : undefined;
    const { language } = i18n;

    const intercomSettings: Intercom_.IntercomSettings = {};

    if (customer) {
      intercomSettings.user_id = customer.id;
      // intercomSettings['name'] = `${customer.firstName} ${customer.lastName}`;
      intercomSettings.name = '  ';
      intercomSettings.phone = customer.phone;
      intercomSettings.language_override = language;

      if (!customer.email.startsWith('auto-generated-')) {
        intercomSettings.email = customer.email.replace('+careem', '');
      }
      if (customer.email.includes('auto-generated')) {
        // Unsubscribed invalid emails from intercom emails
        intercomSettings.unsubscribed_from_emails = true;
      }
    }

    Intercom('boot', {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      hide_default_launcher: true,
      // load initital data if it exists
      ...intercomSettings,
    });

    // hide intercom icon on close
    Intercom('onHide', () => {
      this.hide();
    });
  }

  show() {
    this.update({
      hide_default_launcher: false,
    });
    Intercom('show');
  }

  hide() {
    this.update({
      hide_default_launcher: true,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  update(settings: Intercom_.IntercomSettings) {
    const { email, ...otherSettings } = settings;

    const intercomSettings: Intercom_.IntercomSettings = { ...otherSettings };

    if (email && !email.startsWith('auto-generated-')) {
      intercomSettings.email = email.replace('+careem', '');
    }

    Intercom('update', { ...intercomSettings });
  }

  static destroy() {
    if (MessagingService.instance) {
      Intercom('shutdown');
    }
  }
}
